const cookieWarning = document.querySelector(".js-cookie-DEMO");

if (cookieWarning) {
    const cookieSiteName = cookieWarning.dataset.sitedemo;
    const cookieName = cookieSiteName ? `cookie_warning_${cookieSiteName}` : "cookie_warning";
    const cookieWarningIsHidden = document.cookie
        .split(";")
        .filter((item) => item.includes(`${cookieName}=false`)).length;

    if (!cookieWarningIsHidden) {
        cookieWarning.classList.remove("hidden");
    }

    const closeCookieWarningButton = document.querySelector(".js-cookie-btn");

    if (closeCookieWarningButton) {
        closeCookieWarningButton.addEventListener("click", () => {
            const date = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

            cookieWarning.classList.add("hidden");
            document.cookie = `${cookieName}=false; expires=${date.toUTCString()}`;
        });
    }
}

const cookieBlock = document.querySelector(".cookie");

if (cookieBlock) {
    ["load", "resize"].forEach((evt) =>
        window.addEventListener(evt, () => setDocumentBodyPadding(cookieBlock)),
    );
}

function setDocumentBodyPadding(block) {
    document.body.style.setProperty("--cookie-popup-height", `${block.offsetHeight}px`);
}
